var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('IconBurger',{staticClass:"burger",attrs:{"color":_vm.config.COLOR_PRIMARY},on:{"click":_vm.onBurger}}),_c('router-link',{staticClass:"logo",attrs:{"tag":"img","src":_vm.config.NAVBAR_LOGO,"to":_vm.welcome}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }